import { Field } from "@progress/kendo-react-form";
import { FormRegion } from "../../../../components/formregion";
import {
  FormDropDownList,
  FormRadioGroup,
  FormTextArea,
} from "../../../../forms/form-components";
import { useDispatch, useSelector } from "react-redux";
import { setFormValue } from "../../../../redux/slices/importdatasetpageslice";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const ChooseTableQuery = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.importDatasetPage);
  const { t } = useTranslation();

  const handleOptionChange = (e) => {
    const value = e.value;
    dispatch(setFormValue({ id: "ChooseFrom", value }));
  };

  const importDatasetFromDbList = [
    { label: t("datasets.importdataset.table"), value: "table" },
    { label: t("datasets.importdataset.query"), value: "query" },
  ];

  return (
    <FormRegion>
      <div className="form-group form-group-1">
        <Field
          id={"ChooseFrom"}
          name={"ChooseFrom"}
          label={t("datasets.importdataset.choosefrom")}
          component={FormRadioGroup}
          data={importDatasetFromDbList}
          value={pageState.formValues.ChooseFrom}
          onChange={handleOptionChange}
        />
        {pageState.formValues.ChooseFrom == "table" && (
          <Field
            id={"Table"}
            name={"Table"}
            component={FormDropDownList}
            data={pageState.lst_of_tables}
            onChange={(e) =>
              dispatch(setFormValue({ id: "Table", value: e.value }))
            }
          />
        )}
        {pageState.formValues.ChooseFrom == "query" && (
          <Field
            id={"Query"}
            name={"Query"}
            component={FormTextArea}
            onChange={(e) =>
              dispatch(setFormValue({ id: "Query", value: e.value }))
            }
          />
        )}
      </div>
    </FormRegion>
  );
};

export default ChooseTableQuery;
